var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virtual-scroller-slot-wrapper",style:({ width: _vm.width, height: _vm.height })},[(_vm.isLoader)?_c('div',{staticClass:"full flex-center"},[_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"primary"}})],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }